var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._v("\n  " + _vm._s(_vm.getPhoneNumber) + "\n  "),
      _vm.rejectCalls
        ? _c(
            "el-tooltip",
            {
              staticClass: "ml-1",
              attrs: {
                content: "Reject all inbound calls",
                placement: "top",
                effect: "light",
              },
            },
            [_c("i", { staticClass: "fas fa-phone-slash" })]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }